import axios from "axios";
import { API_BASE_URL } from "../../../constants/apiConstants";

export const getUserRole = async (payload, token) => {
  const url = `${API_BASE_URL}backoffice/UsuarioBackoffice/GetRole`;

  try {
    const response = await axios.post(url, payload, {
      headers: {
        "accept": "text/plain",
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("❌ Error al obtener rol del usuario:", error);
    console.error("❌ Error details:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });

    if (error.response?.status === 401 || error.response?.status === 403) {
      sessionStorage.clear();
      localStorage.clear();
      window.location.href =`${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : ""}/backoffice`;
    }

    throw error; // Re-throw para que el error sea manejado en el componente
  }
};